module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitler-a"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Old Israel")])]), _vm._v(" "), _c('h3', {
    staticClass: "chaptitle1-a2",
    attrs: {
      "id": "ch2-9"
    }
  }, [_vm._v("THE TORAH")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-as"
  }, [_vm._v("After the Israelites arrived in the wilderness of Sinai, three years after their departure from Egypt, the Lord revealed to Moses the law which he transmitted to the Jewish people. Found in the Pentateuch, or first five books of the Old Testament, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torah")]), _vm._v(" is the “constitution” of the Jewish people. The word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torah")]), _vm._v(" literally means “the law” or “direction” or “guidance.” All other sources of Jewish law are an outgrowth or dependent on the early teachings of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Torah")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center-a"
  }, [_vm._v("FROM "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("LEVITICUS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And when ye reap the harvest of your land, thou shalt not wholly reap the corners of thy field, neither shalt thou gather the gleanings of thy harvest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And thou shalt not glean thy vineyard, neither shalt thou gather "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("every")]), _vm._v(" grape of thy vineyard; thou shalt leave them for the poor and stranger: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ye shall not steal, neither deal falsely, neither lie one to another.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And ye shall not swear by my name falsely, neither shalt thou profane the name of thy God: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt not defraud thy neighbour, neither rob "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him:")]), _vm._v(" the wages of him that is hired shall not abide with thee all night until the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt not curse the deaf, nor put a stumbling-block before the blind, but shalt fear thy God: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ye shall do no unrighteousness in judgment; thou shalt not respect the person of the poor, nor honour the person of the mighty: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but")]), _vm._v(" in righteousness shalt thou judge thy neighbour.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt not go up and down "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("as")]), _vm._v(" a tale-bearer among thy people; neither shalt thou stand against the blood of thy neighbour; I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt not hate thy brother in thy heart: thou shalt not in any wise rebuke thy neighbour, and not suffer sin upon him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt not avenge, nor bear any grudge against the children of thy people, but thou shalt love thy neighbour as thyself: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ye shall not eat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any thing")]), _vm._v(" with the blood: neither shall ye use enchantment, nor observe times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regard not them that have familiar spirits, neither seek after wizards, to be defiled by them: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt rise up before the hoary head, and honour the face of the old man, and fear thy God: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if a stranger sojourn with thee in your land, ye shall not vex him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But")]), _vm._v(" the stranger that dwelleth with you shall be unto you as one born among you, and thou shalt love him as thyself; for ye were strangers in the land of Egypt; I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ye shall do no unrighteousness in judgment, in meteyard, in weight, or in measure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just balances, just weights, a just ephah, and a just hin shall ye have: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God, which brought you out of the land of Egypt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Therefore shall ye observe all my statutes, and all my judgments, and do them: I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center-att1"
  }, [_vm._v("XIX")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" spake unto Moses in mount Sinai saying, Speak unto the children of Israel, and say unto them, When ye come into the land which I give you then shall the land keep a sabbath unto the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Six years thou shalt sow thy field, and six years thou shalt prune thy vineyard, and gather in the fruit thereof;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But in the seventh year shall be a sabbath of rest unto the "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("land, a sabbath for the Lord; thou shalt neither sow thy field, nor prune thy vineyard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That which groweth of its own accord of thy harvest, thou shalt not reap, neither gather the grapes of thy vine undressed: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("for")]), _vm._v(" it is a year of rest unto the land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the sabbath of the land shall be meat for you; for thee, and for thy servant, and for thy maid, and for thy hired servant, and for thy stranger that sojourneth with thee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And for thy cattle, and for the beasts that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" in thy land, shall all the increase thereof be meat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And thou shalt number seven sabbaths of years unto thee, seven times seven years; and the space of the seven sabbaths of years shall be unto thee forty and nine years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then shalt thou cause the trumpet of the jubilee to sound on the tenth "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("day")]), _vm._v(" of the seventh month, in the day of atonement shall ye make the trumpet sound throughout all your land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And ye shall hallow the fiftieth year, and proclaim liberty throughout "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("all")]), _vm._v(" the land unto all the inhabitants thereof: it shall be a jubilee unto you; and you shall return every man unto his possession, and ye shall return every man unto his family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A jubilee shall that fiftieth year be unto you: ye shall not sow, neither reap that which groweth of itself in it, nor gather "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the grapes")]), _vm._v(" in it of thy vine undressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" the jubilee; it shall be holy unto you: ye shall eat the increase thereof out of the field.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the year of this jubilee ye shall return every man unto his possession.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if thou sell aught unto thy neighbour, or buyest "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aught")]), _vm._v(" of thy neighbour’s hand, ye shall not oppress one another:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the number of years after the jubilee, thou shalt buy of thy neighbour, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" according unto the number of years of the fruits he shall sell unto thee:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the multitude of years thou shalt increase the price thereof, and according to the fewness of years thou "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("shalt diminish the price of it: for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("according")]), _vm._v(" to the number "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of the years")]), _vm._v(" of the fruits doth he sell unto thee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ye shall not therefore oppress one another; but thou shalt fear thy God: for I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wherefore ye shall do my statutes, and keep my judgments, and do them; and ye shall dwell in the land in safety.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the land shall yield her fruit, and ye shall eat your fill, and dwell therein in safety.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if ye shall say, What shall we eat the seventh year? behold, we shall not sow nor gather in our increase:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I will command my blessing upon you in the sixth year, and it shall bring forth fruit for three years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And ye shall sow the eighth year, and eat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yet")]), _vm._v(" of old fruit until the ninth year; until her fruits come in ye shall eat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of")]), _vm._v(" the old "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("store")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The land shall not be sold for ever; for the land "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" mine, for ye "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" strangers and sojourners with me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And in all the land of your possession ye shall grant a redemption for the land.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If thy brother be waxen poor, and hath sold away "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("some")]), _vm._v(" of his possession, and if any of his kin come to redeem it, then shall he redeem that which his brother sold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if the man have none to redeem it, and himself be able to redeem it;")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then let him count the years of the sale thereof, and restore the overplus unto the man to whom he sold it; that he may return unto his possession.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But if he be not able to restore "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("it")]), _vm._v(" to him, then that which is sold shall remain in the hand of him that hath bought it until the year of jubilee: and in the jubilee it shall go out, and he shall return unto his possession.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if a man sell a dwelling-house in a walled city, then he may redeem it within a whole year after it is sold: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("within")]), _vm._v(" a full year may he redeem it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if it be not redeemed within the space of a full year, then the house that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" in the walled city shall be established "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("for ever to him that bought it, throughout his generations: it shall not go out in the jubilee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the houses of the villages which have no walls round about them, shall be counted as the fields of the country: they may be redeemed, and they shall got out in the jubilee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Notwithstanding the cities of the Levites, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" the houses of the cities of their possession, may the Levites redeem at any time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if a man purchase of the Levites, then the house that was sold, and the city of his possession shall go out in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the year of")]), _vm._v(" jubilee; for the houses of the cities of the Levites "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are their possession among the children of Israel")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the field of the suburbs of their cities may not be sold, for it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" their perpetual possession.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if thy brother be waxen poor, and fallen in decay with thee; then thou shalt relieve him: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yea, though he he")]), _vm._v(" a stranger, or a sojourner; that he may live with thee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Take thou no usury of him, or increase; but fear thy God; that thy brother may live with thee.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt not give him thy money upon usury, nor lend him thy victuals for increase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(" your God, which brought you forth out of the land of Egypt, to give you the land of Canaan, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" to be your God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And if thy brother "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that dwelleth")]), _vm._v(" by thee be waxen poor, and be sold unto thee; thou shalt not compel him to serve as a bond-servant:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("But")]), _vm._v(" as a hired servant, and as a sojourner he shall be with thee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" shall serve thee unto the year of jubilee:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("then")]), _vm._v(" shall he depart from thee, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("both")]), _vm._v(" he and his children with him, and shall return unto his own family, and unto the possession of his fathers shall he return.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" my servants which I brought forth out of the land of Egypt; they shall not be sold as bond-men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thou shalt not rule over him with rigour, but shalt fear thy God.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f3e758","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/18_Chapter029.vue
// module id = 120
// module chunks = 0